<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.keyword"  clearable placeholder="请输入关键字（模糊）"
        @input="removeBlank(tableParams.keyword, 'keyword')" />
      <el-input v-model="tableParams.preciseKeyword"  clearable placeholder="请输入关键字（精确）"
        @input="removeBlank(tableParams.preciseKeyword, 'preciseKeyword')" />
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px">
        <el-button @click="
          downExcel(
            '/webReportKeyword/total/list/csv',
            '总关键字报表',
            tableParams
          )
        " type="warning" size="small">下载</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        highlight-current-row size="small" class="js-table" style="width: 100%" @sort-change="sortChange">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center" :sortable="
            v.field === 'showSmt' ||
            v.field === 'timeKey' ||
            v.field === 'keyword' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'hitRate' ||
            v.field === 'expensesEcpm' ||
            v.field === 'auctionPrice' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeEcpm' ||
            v.field === 'incomeAge' ||
            v.field === 'winPrice' ||
            v.field === 'clkSmt'
          ">
          <template v-slot="scope">
            <el-tag v-if="
              v.field === 'showRat' ||
              v.field === 'clickRate'
            " type="info">{{ scope.row[v.field] }}%</el-tag>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px" />
    </div>
  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'

export default {
  name: 'Manage/keyword/totalWord',
  components: {
    TableColumn,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'timeKey', title: '日期' },
        { field: 'keyword', title: '关键字' },
        // { field: 'dspType', title: '请求数' },
        { field: 'hit', title: '命中数' },
        { field: 'showSmt', title: '展示数' },
        { field: 'showRat', title: '展示率' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'expensesEcpm', title: '支出ecpm' },
        { field: 'auctionPrice', title: '支出' },
        { field: 'expensesAge', title: '支出均价' },
        { field: 'incomeEcpm', title: '收入ecpm' },
        { field: 'winPrice', title: '收入' },
        { field: 'incomeAge', title: '收入均价' }
        // { field: 'contactPhone', title: '下载数' },
        // { field: 'hitRate', title: '命中率' }
      ]
    }
  },
  created() { },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      this.tableUrl = '/webReportKeyword/total/list'
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ""
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ""
      }
      this.init()
    },
    // toQuery() {
    //   this.tableParams.pageNum = this.pagination.pageNum
    //   this.tableParams.pageSize = this.pagination.pageSize
    //   this.init()
    // },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
